/**
 * Activates toggle functionality for header search.
 * Gets references to header elements.
 * Defines toggleHeaderSearch() to toggle active classes on header elements.
 * Adds focus/blur event listeners on search input to trigger toggle.
 * On DOM load, calls activateToggleHeaderSearch().
 */
(function () {
  const xHeader = document.querySelector('[data-name="main-header"]');
  const headerSearch = document.querySelector('[data-name="header-search"]');
  const predictiveSearch = document.querySelector('[data-name="predictive-search"]');
  const headerSearchInput = document.querySelector('[data-name="header-search-input"]');
  const headerPrediAlt = document.querySelector('[data-name="header-predictive-search-alternative"]');
  const headerSearchIcon = document.querySelector('[data-name="header-search-icon"]');
  const headerCloseBtn = document.querySelector('[data-name="header-search-close-button"]');
  function activateToggleHeaderSearch() {
    function hideHeaderSearch() {
      setTimeout(() => {
        if (xHeader.classList.contains("active")) {
          document.getElementById("predictive-search-form").reset();
          headerSearchInput.blur();
          headerSearch.classList.remove("active");
          predictiveSearch.classList.remove("active");
          document.documentElement.classList.remove("lock");
          headerPrediAlt.style.display = "none";
          xHeader.classList.remove("active");
          // headerSearch.removeAttribute("open", false);
        }
      }, 260);
    }
    function showHeaderSearch() {
      if (!xHeader.classList.contains("active")) {
        xHeader.classList.add("active");
        headerSearch.classList.add("active");
        predictiveSearch.classList.add("active");
        document.documentElement.classList.add("lock");
        headerPrediAlt.style.display = "block";
        // headerSearch.setAttribute("open", true);
      }
    }
    headerSearchInput.addEventListener("focus", showHeaderSearch);
    headerSearchIcon.addEventListener("click", showHeaderSearch);
    headerCloseBtn.addEventListener("click", hideHeaderSearch)

    // if (window.innerWidth >= 1008) {
    setTimeout(() => {
      headerSearchInput.addEventListener("focusout", hideHeaderSearch);
    }, 50);
    // }

    if (window.innerWidth < 1008) {
      headerSearchInput.focus();
    }
  }


  document.addEventListener("DOMContentLoaded", function () {
    activateToggleHeaderSearch();
  });

  function hideRecommendedProds() {
    if (headerSearchInput.value.length >= 1) {
      headerPrediAlt.style.display = "none";
    } else {
      headerPrediAlt.style.display = "block";
    }
  }

  headerSearchInput.addEventListener("input", hideRecommendedProds);
  setTimeout(() => {
    document.querySelector('[data-name="header-search-form"]').firstElementChild.classList.remove("roll-down");
    document.querySelector('[data-name="header-search-form"]').firstElementChild.classList.add("roll-up");
  }, 50);
})();
